// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0af39837","455":"05345ffa","977":"5fa6d925"}[chunkId] + ".chunk.js";
};